import { VideoFileUrl } from "../model/videofile";
import { api } from "./api";


export const putVideo = async (accessToken: string, video: File): Promise<VideoFileUrl> => {
    const form = new FormData();
    form.set('video', video)

    const response = await api.put<VideoFileUrl>(`/videos`, form, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return response.data as VideoFileUrl;
};